/**
 * Alpine.js Theme Editor Re-initialization Handler
 * 
 * When Shopify Theme Editor re-renders sections, Alpine components lose their state.
 * This script listens for Theme Editor events and re-initializes Alpine on affected sections.
 */
document.addEventListener('DOMContentLoaded', function() {
  // Handle Theme Editor section reloads - re-initialize Alpine on newly loaded sections
  document.addEventListener('shopify:section:load', function(event) {
    if (window.Alpine) {
      Alpine.initTree(event.target);
    }
  });

  // Handle block-level events for nested Alpine components
  document.addEventListener('shopify:block:select', function(event) {
    if (window.Alpine) {
      Alpine.initTree(event.target);
    }
  });
});
